export function homeownerWarningNoticeRightToCancel() {
return [   // Release 2026-10-02 10:31:12
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Date Contract Date", 
   fontSize: 9,
   type: "date",
   top: 325.8,
   left: 225.0,
   width: 80.672,
   height: 12.72
}
,
{
   page: 0,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 365.88,
   left: 63.84,
   width: 501.36,
   height: 14.04
}
,
{
   page: 0,
   name: "Language", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 525.6,
   left: 376.56,
   width: 185.88,
   height: 14.04
}
,
{
   page: 0,
   name: "Notice in Sellers language", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 557.04,
   left: 60.24,
   width: 490.32,
   height: 165.72
}
,
{
   page: 0,
   name: "Text14", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 325.311,
   left: 309.601,
   width: 161.782,
   height: 12.836
}
,
{
   page: 1,
   name: "Buyer 1 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 27.48,
   left: 119.04,
   width: 427.92,
   height: 13.102
}
,
{
   page: 1,
   name: "Buyer 2 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 82.56,
   left: 119.44,
   width: 427.92,
   height: 13.102
}
,
{
   page: 1,
   name: "Buyer 3 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 139.2,
   left: 118.72,
   width: 427.92,
   height: 13.102
}
,
{
   page: 1,
   name: "Buyer 4 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 194.04,
   left: 118.72,
   width: 427.92,
   height: 13.102
}
,
{
   page: 1,
   name: "Seller 1 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 258.36,
   left: 120.04,
   width: 427.92,
   height: 13.102
}
,
{
   page: 1,
   name: "Seller 2 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 313.32,
   left: 119.44,
   width: 427.92,
   height: 13.102
}
,
{
   page: 1,
   name: "Seller 3 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 367.92,
   left: 118.72,
   width: 427.92,
   height: 13.102
}
,
{
   page: 1,
   name: "Seller 4 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 422.88,
   left: 118.72,
   width: 427.92,
   height: 13.102
}
] }
